import MotivoRejeicaoModel from "@/models/motivoRejeicaoModel";

import { IService } from "./base/iService";

export default class MotivoRejeicaoService extends IService<MotivoRejeicaoModel> {
    constructor() {
        super("MotivoRejeicao");
    }
}
